import { createSlice } from "@reduxjs/toolkit";
import { login , register, getOneUser, getVerificationCode, editUser, getSettings, getConditions, getRateQuestions } from "./thunk"; // Import the async thunks

const initialState = {
  users: [],
  loginResponse:null,
  registerResponse:null,
  loading: false,
  error: null,
  oneUser:null,
  verificationCode:null,
  editUserState:null,
  settings:null,
  conditions:null,
  questions:[]
};

const usersSlice = createSlice({
  name: "usersSlice",
  initialState,
  reducers: {
    clearResponses: (state) => {
      state.loginResponse = null;
      state.registerResponse = null;
    }
  },
  extraReducers: (builder) => {
    builder

    // login
      .addCase(login.pending, (state) => {
        state.loading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.loginResponse = action.payload
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
      


      builder
      // register
        .addCase(register.pending, (state) => {
          state.loading = true;
        })
        .addCase(register.fulfilled, (state, action) => {
          state.loading = false;
          state.registerResponse = action.payload
        })
        .addCase(register.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        });

      builder
      // register
        .addCase(getOneUser.pending, (state) => {
          state.loading = true;
        })
        .addCase(getOneUser.fulfilled, (state, action) => {
          state.loading = false;
          state.oneUser = action.payload
        })
        .addCase(getOneUser.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        });

      builder
      // register
        .addCase(editUser.pending, (state) => {
          state.loading = true;
        })
        .addCase(editUser.fulfilled, (state, action) => {
          state.loading = false;
          state.editUserState = action.payload
        })
        .addCase(editUser.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        });
      builder
      // register
        .addCase(getVerificationCode.pending, (state) => {
          state.loading = true;
        })
        .addCase(getVerificationCode.fulfilled, (state, action) => {
          state.loading = false;
          state.verificationCode = action.payload
        })
        .addCase(getVerificationCode.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        });
      builder
      // settings
        .addCase(getSettings.pending, (state) => {
          state.loading = true;
        })
        .addCase(getSettings.fulfilled, (state, action) => {
          state.loading = false;
          state.settings = action.payload
        })
        .addCase(getSettings.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        });
      builder
      // settings
        .addCase(getConditions.pending, (state) => {
          state.loading = true;
          state.conditions = null
        })
        .addCase(getConditions.fulfilled, (state, action) => {
          state.loading = false;
          state.conditions = action.payload
        })
        .addCase(getConditions.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        });
      builder
      // settings
        .addCase(getRateQuestions.pending, (state) => {
          state.loading = true;
          state.questions = null
        })
        .addCase(getRateQuestions.fulfilled, (state, action) => {
          state.loading = false;
          state.questions = action.payload
        })
        .addCase(getRateQuestions.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        });

  },
  

});

export default usersSlice.reducer;
